import { Injectable } from '@angular/core';
import { ApiConfig } from '../config/apiConfig';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfService } from 'src/conf.service';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { CreateTicketFormFields } from 'src/app/models/tickets/createTicketFormFields'
@Injectable({
  providedIn: 'root'
})
export class TicketsService { 
  private ticketGlobalData: BehaviorSubject<CreateTicketFormFields> = new BehaviorSubject<CreateTicketFormFields>(new CreateTicketFormFields());
    public setTicketGlobalData(data: any){
        this.ticketGlobalData.next(data);
    }
    public getTicketGlobalData(): Observable<any> {
        return this.ticketGlobalData.asObservable();
    }
  private rootUrl: string;
  private ticketsAPIUrl;
  constructor(private http: HttpClient) {
    this.rootUrl = ConfService.conf.environment.apiRootUrl;
    this.ticketsAPIUrl = ApiConfig.TicketApiConfig;
   }

  	
	clearTicketTestEquip(ticketsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.ticketsAPIUrl.clearTicketTestEquip}`, ticketsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	clearTicketParts(ticketsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.ticketsAPIUrl.clearTicketParts}`, ticketsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	dashTickets(ticketsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.ticketsAPIUrl.dashTickets}`,ticketsObj )
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	getTicket(ticketsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.ticketsAPIUrl.getTicket}`, ticketsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	getTicketParts(ticketsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.ticketsAPIUrl.getTicketParts}`, ticketsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	getTicketPartSource(ticketsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.ticketsAPIUrl.getTicketPartSource}`, ticketsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	loadTicketQuestion(ticketsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.ticketsAPIUrl.loadTicketQuestion}`, ticketsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	addTicketNote(ticketsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.ticketsAPIUrl.addTicketNote}`, ticketsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	addTicketPart(ticketsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.ticketsAPIUrl.addTicketPart}`, ticketsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	saveTicketQuestion(ticketsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.ticketsAPIUrl.saveTicketQuestion}`, ticketsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	getTicketRecords(ticketsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.ticketsAPIUrl.getTicketRecords}`, ticketsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	updateTicket(ticketsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.ticketsAPIUrl.updateTicket}`, ticketsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	CloseBatchTicket(ticketsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.ticketsAPIUrl.CloseBatchTicket}`, ticketsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}
	
	addTicketTestEquip(ticketsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.ticketsAPIUrl.addTicketTestEquip}`, ticketsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	addBatchTicketParts(ticketsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.ticketsAPIUrl.addBatchTicketParts}`, ticketsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	checkBatchEquipment(ticketsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.ticketsAPIUrl.checkBatchEquipment}`, ticketsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	CreateBatchTicket(ticketsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.ticketsAPIUrl.CreateBatchTicket}`, ticketsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	closeTicket(ticketsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.ticketsAPIUrl.closeTicket}`, ticketsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}
	
	createTicket(ticketsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.ticketsAPIUrl.createTicket}`, ticketsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	createTicketFromServiceRequest(ticketsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.ticketsAPIUrl.createTicketFromServiceRequest}`, ticketsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	getTicketTestEquip(ticketsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.ticketsAPIUrl.getTicketTestEquip}`, ticketsObj)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  voidClosedTicket(ticketsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.ticketsAPIUrl.voidClosedTicket}`, ticketsObj)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  
}
